import { createSharingLinkView } from './components/createSharingLinkView';
import { closeLinkContextMenu, showLinkContextMenu } from './components/LinkContextMenu';
import { displaySpinnerOverlay } from './components/SpinnerOverlay';
import './mutators';
import './orchestrators/deleteLinkOrchestrator';
import getComposeLinkViewState from './selectors/getComposeLinkViewState';
import { createLoadingLinkView } from './components/LoadingLink';
import isContextMenuOpen from './selectors/isContextMenuOpen';

// exported constants
export {
    LINK_CONTEXT_MENU,
    OWA_AUTO_LINKS_CLASSNAME,
    SAFELINK_ORIGINALSRC_ATTRIBUTE_NAME,
    SPAN_TAG_NAME,
} from './utils/constants';

// export public actions
export {
    addComposeLinkViewState,
    onLinkSelectionChange,
    previewSharePointDocumentLinkInSxS,
    removeAllComposeLinkViewStates,
} from './actions/publicActions';
export {
    getComposeLinkViewState,
    createSharingLinkView,
    createLoadingLinkView,
    isContextMenuOpen,
    showLinkContextMenu,
    closeLinkContextMenu,
    displaySpinnerOverlay,
};
